import {Component, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AppLang, LanguageService} from '../../services/language/language.service';

/**
 * Selector de idioma reutilizable (segmentado ES|EN). Pensado para fondos oscuros.
 * Persiste la elección vía LanguageService.
 */
@Component({
  selector: 'app-language-switcher',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="lang-switch" role="group" aria-label="Language selector">
      <button
        *ngFor="let l of langs"
        type="button"
        class="lang-opt"
        [class.active]="current === l.code"
        [attr.aria-pressed]="current === l.code"
        (click)="select(l.code)">
        {{ l.label }}
      </button>
    </div>
  `,
  styles: [`
    .lang-switch {
      display: inline-flex;
      align-items: center;
      gap: 2px;
      padding: 3px;
      border-radius: 999px;
      background: rgba(255, 255, 255, 0.06);
      border: 1px solid rgba(255, 255, 255, 0.14);
      backdrop-filter: blur(6px);
    }

    .lang-opt {
      appearance: none;
      border: 0;
      background: transparent;
      color: rgba(255, 255, 255, 0.62);
      font: inherit;
      font-size: 0.76rem;
      font-weight: 700;
      letter-spacing: 0.03em;
      line-height: 1;
      padding: 5px 11px;
      border-radius: 999px;
      cursor: pointer;
      transition: color 0.15s ease, background 0.15s ease;
    }

    .lang-opt:hover {
      color: rgba(255, 255, 255, 0.92);
    }

    .lang-opt.active {
      color: #0c0e12;
      background: #f5b301;
    }
  `],
})
export class LanguageSwitcherComponent {
  private langSvc = inject(LanguageService);

  readonly langs: { code: AppLang; label: string }[] = [
    {code: 'es', label: 'ES'},
    {code: 'en', label: 'EN'},
  ];

  get current(): AppLang {
    return this.langSvc.current();
  }

  select(lang: AppLang): void {
    this.langSvc.set(lang);
  }
}
